import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
// import { Skills } from './components';
const Skills = lazy(() => import(/* webpackChunkName: "Skills" */'./components'));
const routes = () => (
  <PrivateRoute exact path="/settings/Skills" component={Skills} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/Skills/routes.js